import React, { useEffect, useState } from 'react';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import axios from 'axios';
import {flatObject} from '../../../utils/flat';
import {useCookies} from 'react-cookie';
import dateSetting from '../../../utils/dateSetting';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import PitcherSeasonRecordComponent from '../../../components/record/PitcherSeasonRecordComponent';

function PitcherPlayerSeasonRecord({profile, leagueType}) {
    const [cookies] = useCookies(['hiball_token']);
    let [seasonRecord, setSeasonRecord] = useState({});
    let {type} = profile;
    const { t } = useTranslation();

    useEffect(() => {
        let dateObj = dateSetting();
        let playerId = profile['playerId'];
        let params = {
            pitcherIds: playerId,
            authToken:JSON.stringify(cookies['hiball_token'])
        }

        if(leagueType === 4201) {
            params['gameTypeCode'] = leagueType;
            params['recordType'] = 'digestPitchingRecord';
            params['recordName'] = 'selectSeasonRecord';
        } else {
            params['recordType'] = 'futuresRecordService';
            params['recordName'] = 'futuresPitcherRecord';
        }

        const seasonParam = {...params, seasons: dateObj['season']};
        const beforeSeasonParam = {...params, seasons: dateObj['season']-1}

        const seasonPromise = fetchFunc(seasonParam);
        const beforeSeasonPromise = fetchFunc(beforeSeasonParam);

        Promise.all([
            seasonPromise, beforeSeasonPromise
        ]).then((response) => {
            const seasonData = response[0]['data']['result'][0];
            const beforeSeasonData = response[1]['data']['result'][0];

            if(_.isUndefined(seasonData)) {
                setSeasonRecord(flatObject(beforeSeasonData));
            } else {
                setSeasonRecord(flatObject(seasonData));
            }
        });
    }, []);

    async function fetchFunc(params) {
        return new Promise((resolve, reject) => {
            axios({
                url : `${process.env.REACT_APP_API_URL}`,
                params
            }).then((result) => {
                resolve(result);
            });
        })
    }

    if(Object.keys(seasonRecord).length === 0 ) {
        return <DefaultLoader />
    }

    return (
        <div className="profileRecordBox">
            <div className="recordTitle">
                {(seasonRecord['season'] || '')+" "+t('seasonStats')}
            </div>
            <div className="recordBox">
                <PitcherSeasonRecordComponent record={seasonRecord} leagueType={leagueType}/>
            </div>
        </div>
    )
}

export default PitcherPlayerSeasonRecord;